import { Fragment, useRef, useState } from "react";
import { Link } from "react-router-dom";

// components
import DisplayPlatforms from "@components/layout/display-platforms";
import ClickToCopy from "@components/shared/click-to-copy";
import IconStatus from "@assets/icons/IconStatus";
// utilities
import { convertISODateTime } from "@utils/time-helpers";

// resources
import { STATIC_URL } from "@lib/config";
import colors from "@styles/colors";
import { filePreviewNotAvailable } from "@assets/images";

const styles = {
  verticalCenter: {
    display: "flex",
    alignItems: "center",
  },
  thumbnailPreviewContainer: {
    display: "flex",
    height: "100px",
    width: "90%",
    borderRadius: "1px",
    justifyContent: "center",
    alignItems: "center",
  },
  defaultIconIndicator: {
    stroke: "rgba(0,0,0,0.19)",
    strokeWidth: "1",
    marginTop: "3px",
  },
};

const TableRow = (props) => {
  const [hoverOn, onHoverChange] = useState(false);
  const [innerHoverOn, onInnerHoverChange] = useState([]);
  let { tableConfig, tableRowObj, customStyling = {
    rowBody: {
      height: "142px",
    },
    rowBottom: {
      marginBottom: "10px",
    },
  } } = props;
  let showBottomRightDiv = tableConfig.showBottomRightDiv
    ? tableConfig.showBottomRightDiv(tableRowObj)
    : false;
  let isShaded = tableConfig.getShadedStatus
    ? tableConfig.getShadedStatus(tableRowObj)
    : false;
  let innerTableConfig = tableConfig.innerColumnKey
    ? {
        ...tableConfig,
        voidLink: tableConfig.voidInnerLink,
        constructLinkTo: tableConfig.constructInnerLinkTo,
        onClickCallback: tableConfig.onClickInnerCallback,
        clickContainer: tableConfig.clickContainer,
        constructHref: tableConfig.constructInnerHref,
        showBottomRightDiv: tableConfig.showInnerBottomRightDiv,
        constructBottomRightDiv: tableConfig.constructInnerBottomRightDiv,
        columns: tableConfig.innerColumns, //check promo, banner, notifications for more on the config table
      }
    : null;
  const InnerHoverHelper = (innerHoverOn, index, value) => {
    innerHoverOn[index] = value;
    return [...innerHoverOn];
  };
  let rowEl = (columns, tableRowObjData, useInnerHover, currentIndex) => (
    <div
      className={"tableRow-clickable"}
      onMouseOver={() =>
        useInnerHover
          ? onInnerHoverChange(
              InnerHoverHelper(innerHoverOn, currentIndex, true)
            )
          : onHoverChange(true)
      }
      onMouseOut={() =>
        useInnerHover
          ? onInnerHoverChange(
              InnerHoverHelper(innerHoverOn, currentIndex, false)
            )
          : onHoverChange(false)
      }
      style={{
        ...(useInnerHover
          ? { width: "100%", marginLeft: "0%" }
          : { width: "95%", marginLeft: "2.5%" }),
        backgroundColor: isShaded ? "#F4F4F4" : "inherit",
        boxShadow:
          (useInnerHover && innerHoverOn[currentIndex]) ||
          (!useInnerHover && hoverOn)
            ? "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)"
            : "1px 1px 3px 1px rgba(0,0,0,0.1)",
        ...customStyling.rowBody,
      }}
    >
      {typeof tableConfig.getItemStatus === "function" ? (
        <div className="h-5">
          <IconStatus
            theme={(tableConfig.getItemStatus(tableRowObj) || "").toUpperCase()}
          />
        </div>
      ) : null}
      <div className="flex h-20">
        {columns.map((column, index) => {
          switch (column.componentType) {
            // banners table
            // promotions table
            case "id-and-image-and-platforms":
              let isImage =
                column.dataKeys.imageId ||
                column.dataKeys.imageURL ||
                (tableRowObjData[column.dataKeys.contentKey] &&
                  tableRowObjData[column.dataKeys.contentKey].includes(
                    "image"
                  ));
              let imgSrc = column.dataKeys.imageId
                ? STATIC_URL +
                  tableRowObjData[column.dataKeys.imageId] +
                  "/300/300"
                : tableRowObjData[column.dataKeys.imageURL] ||
                    tableRowObjData[column.dataKeys.fileURL]
                  ? tableRowObjData[
                      column.dataKeys.imageURL || column.dataKeys.fileURL
                    ]
                  : column.imageNotAvailable;
              return (
                <div
                  key={index}
                  className="tableRow-id-column"
                  style={{
                    width: column.customWidth
                      ? column.customWidth
                      : column.width,
                    padding: "5px 0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {isImage ? (
                    <div
                      className="tableRow-image-container row-thumbnail"
                      style={styles.thumbnailPreviewContainer}
                    >
                      <img
                        className="img tableRow-image"
                        data-testid="table-row-image"
                        style={{ maxHeight: "100%", maxWidth: "100%" }}
                        src={imgSrc}
                      />
                      <img
                        className="img tableRow-image-enlarge"
                        data-testid="table-row-image-enlarge"
                        src={imgSrc}
                      />
                    </div>
                  ) : tableRowObjData[column.dataKeys.contentKey] ? (
                    <div
                      className="tableRow-url-preview-container row-thumbnail"
                      style={styles.thumbnailPreviewContainer}
                    >
                      <object
                        className="img tableRow-image"
                        style={{ maxHeight: "100%", maxWidth: "100%" }}
                        data={tableRowObjData[column.dataKeys.fileURL]}
                        {...(tableRowObjData[column.dataKeys.fileURL]
                          ? {
                              type: tableRowObjData[column.dataKeys.contentKey],
                            }
                          : {})}
                      >
                        <img
                          className="tableRow-image"
                          style={{ height: "100px" }}
                          src={filePreviewNotAvailable}
                        />
                      </object>
                      <object
                        className="img tableRow-image-enlarge"
                        data={tableRowObjData[column.dataKeys.fileURL]}
                        {...(tableRowObjData[column.dataKeys.fileURL]
                          ? {
                              type: tableRowObjData[column.dataKeys.contentKey],
                            }
                          : {})}
                      >
                        <img
                          style={{ maxHeight: "35vh", maxWidth: "35vw" }}
                          src={filePreviewNotAvailable}
                        />
                      </object>
                    </div>
                  ) : null}
                  <div
                    className="tableRow-id-and-platforms"
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      className="rc-standard"
                      style={{
                        padding: "5px 0",
                        width: column.idWidth ? column.idWidth : "102px",
                      }}
                    >
                      {column.idLabel && `${column.idLabel}:`}
                      <span
                        className="rc-rowStyle-id"
                        data-testid="table-row-id"
                        style={{ paddingLeft: "3px" }}
                      >
                        {tableRowObjData[column.dataKeys.id]}
                      </span>
                    </div>
                    <DisplayPlatforms
                      platformId={tableRowObjData[column.dataKeys.platformId]}
                    />
                  </div>
                </div>
              );
              break;

            // banners table
            // promotions table
            case "string":
              const nodeToCopy = useRef(null);
              return (
                <div
                  key={index}
                  className={`tableRow-string ${
                    column.customWidth ? column.customWidth : column.width
                  }${column.clickToCopy ? " flex items-center" : ""}`}
                  style={{
                    ...styles.verticalCenter,
                  }}
                >
                  <div
                    data-testid={"table-row-" + index}
                    className={`rc-standard ${
                      column.wrap ? "rc-wrap" : "rc-ellipsis"
                    }${column.emphasis ? " rc-emphasis" : ""}`}
                    style={{ width: "95%", ...column.styleOverride }}
                    title={tableRowObjData[column.dataKeys.textContent]}
                    ref={nodeToCopy}
                  >
                    {column.formatter
                      ? column.formatter(
                          tableRowObjData[column.dataKeys.textContent]
                        )
                      : tableRowObjData[column.dataKeys.textContent]}
                  </div>
                  {column.clickToCopy && (
                    <ClickToCopy
                      nodeToCopy={nodeToCopy.current}
                      notificationCallback={() =>
                        column.notificationCallback(tableRowObjData)
                      }
                    />
                  )}
                </div>
              );
              break;

            // banners table
            // promotions table
            case "date":
              let {
                toDate: parsedDate,
                toTime: parsedTime,
                toTimeZone: parsedTimeZone,
              } = convertISODateTime(tableRowObjData[column.dataKeys.isoDate]);
              return (
                <div
                  key={index}
                  className="tableRow-date"
                  style={{
                    width: column.customWidth
                      ? column.customWidth
                      : column.width,
                    ...styles.verticalCenter,
                  }}
                >
                  <div
                    data-testid="table-row-date"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="rc-standard rc-emphasis rc-ellipsis">
                      {parsedDate}
                    </span>
                    <span className="rc-standard" style={{ marginTop: "3px" }}>
                      {parsedTime} {parsedTimeZone}
                    </span>
                  </div>
                </div>
              );
              break;
            // banners table
            // promotions table
            case "value-processed":
              return (
                <div
                  key={index}
                  className="tableRow-value-processed"
                  style={{
                    width: column.customWidth
                      ? column.customWidth
                      : column.width,
                    ...styles.verticalCenter,
                  }}
                >
                  <div className="rc-standard">
                    {column.processCallback(tableRowObjData)}
                  </div>
                </div>
              );
              break;
            // promotions table
            case "constructed-div":
              return !column.displayIfKeyExists ? (
                <div
                  key={index}
                  className={`constructed-div ${
                    column.customWidth ? column.customWidth : column.width
                  }`}
                  data-testid="file-name-description"
                  style={{
                    ...styles.verticalCenter,
                  }}
                >
                  {column.constructDiv(tableRowObjData)}
                </div>
              ) : null;
              break;
            case "centered-icon":
              return (
                <div
                  key={index}
                  className={`constructed-div ${
                    column.customWidth ? column.customWidth : column.width
                  }`}
                  style={{
                    ...styles.verticalCenter,
                    justifyContent: "center",
                    ...(column.styleOverride ? column.styleOverride : {}),
                  }}
                >
                  {column.linkTo ? (
                    <Link
                      onClick={() =>
                        column.callbackFirstOnLinkTo && column.onClickCallback
                          ? column.onClickCallback(
                              tableRowObjData,
                              column.linkTo
                            )
                          : column.linkTo(tableRowObjData)
                      }
                      to={column.linkTo(tableRowObjData)}
                    >
                      <img
                        data-testid="add-new-file"
                        src={column.imgLink(tableRowObjData)}
                        style={{
                          height: column.imgSize,
                          width: column.imgSize,
                          ...column.imgAlignment,
                        }}
                      />
                    </Link>
                  ) : (
                    <img
                      data-testid="edit-file"
                      src={column.imgLink(tableRowObjData)}
                      style={{
                        height: column.imgSize,
                        width: column.imgSize,
                        ...column.imgAlignment,
                      }}
                      onClick={() => {
                        if (column.hasOwnProperty("onClickCallback")) {
                          column.onClickCallback(tableRowObjData);
                        }
                      }}
                    />
                  )}
                </div>
              );
              break;
            // banners table
            case "strings-two-lines":
              return (
                <div
                  key={index}
                  className="tableRow-two-lines"
                  style={{
                    width: column.customWidth
                      ? column.customWidth
                      : column.width,
                    ...styles.verticalCenter,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <span
                      className={`rc-standard ${
                        column.wrap ? "rc-wrap" : "rc-ellipsis"
                      }`}
                      data-testid="table-row-type"
                    >
                      {tableRowObjData[column.dataKeys.row1]}
                    </span>
                    <span
                      className={`rc-standard ${
                        column.wrap ? "rc-wrap" : "rc-ellipsis"
                      }`}
                      data-testid="table-row-value"
                      style={{ marginTop: "3px", marginRight: "1px" }}
                    >
                      {tableRowObjData[column.dataKeys.row2]}
                    </span>
                  </div>
                </div>
              );
              break;
            default:
              return (
                <div
                  className="column-type-not-recognized"
                  key={index}
                  style={{
                    width: column.customWidth
                      ? column.customWidth
                      : column.width,
                  }}
                >
                  column type not recognized
                </div>
              );
          }
        })}
      </div>
    </div>
  );
  const svgConstruct = (lastInnerColumn) => {
    let start = "0%",
      halfSpace = "50%",
      fullSpace = "100%";
    return (
      <svg id="line-canvas" style={{ width: fullSpace, height: fullSpace }}>
        <line
          x1={halfSpace}
          x2={halfSpace}
          y1={start}
          y2={halfSpace}
          style={styles.defaultIconIndicator}
        />
        <line
          x1={halfSpace}
          x2={fullSpace}
          y1={halfSpace}
          y2={halfSpace}
          style={styles.defaultIconIndicator}
        />
        {!lastInnerColumn && (
          <line
            x1={halfSpace}
            x2={halfSpace}
            y1={halfSpace}
            y2={fullSpace}
            style={styles.defaultIconIndicator}
          />
        )}
      </svg>
    );
  };
  const typeOfLink = (
    linkConfig,
    tableRowObjData,
    useInnerHover = false,
    currentIndex = null
  ) =>
    linkConfig.voidLink ? (
      rowEl(linkConfig.columns, tableRowObjData, useInnerHover, currentIndex)
    ) : linkConfig.constructLinkTo ? (
      <Link
        onClick={() =>
          linkConfig.onClickCallback
            ? linkConfig.onClickCallback(tableRowObjData)
            : null
        }
        to={linkConfig.constructLinkTo(tableRowObjData)}
      >
        {rowEl(
          linkConfig.columns,
          tableRowObjData,
          useInnerHover,
          currentIndex
        )}
      </Link>
    ) : linkConfig.onClickCallback && linkConfig.clickContainer ? (
      <div
        style={{ cursor: "pointer" }}
        onClick={() =>
          linkConfig.onClickCallback
            ? linkConfig.onClickCallback(tableRowObjData)
            : null
        }
      >
        {rowEl(
          linkConfig.columns,
          tableRowObjData,
          useInnerHover,
          currentIndex
        )}
      </div>
    ) : (
      <a href={linkConfig.constructHref(tableRowObjData)}>
        {rowEl(
          linkConfig.columns,
          tableRowObjData,
          useInnerHover,
          currentIndex
        )}
      </a>
    );
  const consitionalBottomRightDiv = (
    tableConfigObj,
    tableRowObjData,
    useInnerHover = false,
    currentIndex = null
  ) => (
    <div
      className="tableRow-bottom-right-div-container"
      onMouseOver={() =>
        useInnerHover
          ? onInnerHoverChange(
              InnerHoverHelper(innerHoverOn, currentIndex, true)
            )
          : onHoverChange(true)
      }
      onMouseOut={() =>
        useInnerHover
          ? onInnerHoverChange(
              InnerHoverHelper(innerHoverOn, currentIndex, false)
            )
          : onHoverChange(false)
      }
      style={{
        backgroundColor: "red",
        flexDirection: "row",
        position: "relative",
        top: "-10px",
        width: "95%",
        marginLeft: useInnerHover ? "5%" : "2.5%",
        height: "0",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        cursor: "pointer",
      }}
    >
      <div className="tableRow-bottom-right-div">
        {tableConfigObj.constructBottomRightDiv
          ? tableConfigObj.constructBottomRightDiv(tableRowObjData)
          : null}
      </div>
    </div>
  );

  let rowStyle = (
    <Fragment>
      {typeOfLink(tableConfig, tableRowObj)}
      {showBottomRightDiv
        ? consitionalBottomRightDiv(tableConfig, tableRowObj)
        : null}
    </Fragment>
  );
  let innerColumnRow =
    tableConfig.innerColumnKey && tableRowObj[tableConfig.innerColumnKey]
      ? tableRowObj[tableConfig.innerColumnKey].map((innerColumn, index) => {
          return (
            <div
              className="tableRow-inner-column-container"
              key={index}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "95%",
                margin: "0%",
                marginLeft: "2.5%",
              }}
            >
              <div
                className="icon-indicator"
                style={{
                  flex: 1,
                  height: "100%",
                  cursor: "default",
                  ...(index !== 0 ? { marginTop: "-3px" } : {}),
                }}
              >
                {tableConfig.customIconIndicator
                  ? tableConfig.customIconIndicator("8%")
                  : svgConstruct(
                      index ===
                        tableRowObj[tableConfig.innerColumnKey].length - 1
                    )}
              </div>
              <div
                className="tableRow-inner-column"
                style={{
                  width: "92%",
                }}
              >
                {tableConfig.reuseOuterConstruct
                  ? typeOfLink(
                      { ...tableConfig, columns: tableConfig.innerColumns },
                      innerColumn,
                      true,
                      index
                    )
                  : typeOfLink(innerTableConfig, innerColumn, true, index)}
                {tableConfig.reuseOuterConstruct && showBottomRightDiv
                  ? consitionalBottomRightDiv(
                      tableConfig,
                      innerColumn,
                      true,
                      index
                    )
                  : innerTableConfig
                    ? consitionalBottomRightDiv(
                        innerTableConfig,
                        innerColumn,
                        true,
                        index
                      )
                    : null}
              </div>
            </div>
          );
        })
      : null;

  return (
    <div
      className="tableRow"
      data-testid="table-row"
      style={{
        ...customStyling.rowBottom,
      }}
    >
      {rowStyle}
      {tableConfig.innerColumnKey ? innerColumnRow : null}
      {tableConfig.errorCheck && tableConfig.errorCheck(tableRowObj) ? (
        <div
          className="table-row-error-message"
          style={{
            marginLeft: "2.5%",
            marginTop: "5px",
            color: colors.gpshopperBlue,
          }}
        >
          * {tableConfig.errorCheck(tableRowObj)}
        </div>
      ) : null}
    </div>
  );
};

export default TableRow;
